const styles = (theme) => ({
  localeSelector: {
    marginRight: '10px',
    border: `1px solid ${theme.palette.primary.dark}`,
    borderRadius: theme.variables.borderRadius,
    color: theme.palette.text.dark,
    padding: '1px 0',
    '&:hover': {
      color: theme.palette.text.white,
      backgroundColor: theme.palette.primary.dark,
      '& img': {
        filter: 'invert(100%)',
      },
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: 0,
      paddingBottom: 0,
    },
    '& div': {
      [theme.breakpoints.down('sm')]: {
        padding: `2px !important`,
      },
    },
    '& div[aria-pressed="true"] ~ svg': {
      transform: 'rotate(180deg)',
    },
  },
  selectMenu: {
    height: 'auto',
    overflow: 'visible',
    '&:focus': {
      outline: 'none',
      backgroundColor: 'transparent',
    },
    [theme.breakpoints.up('md')]: {
      overflow: 'hidden',
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing.unit,
      paddingRight: 40,
    },
  },
  selectorIcon: {
    position: 'absolute',
    display: 'inline-block',
    width: '40px',
    height: '40x',
    pointerEvents: 'none',
    '&&': {
      top: '5px',
      right: theme.spacing.unit * 0.5,
    },
  },
  languageIcon: {
    width: '24px',
    margin: '0 5px',
  },
  buttonLabel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    '&:focus': {
      outline: '2px solid black',
    },
  },
  buttonLabelText: {
    marginLeft: theme.spacing.unit * 0.5,
    marginRight: theme.spacing.unit * 0.5,
    fontSize: '1.1875rem',
    fontWeight: 500,
  },
  menuHeading: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    height: '60px',
    whitespace: 'normal',
    padding: '10px 20px',
    '&:hover': {
      backgroundColor: 'white',
      cursor: 'default',
    },
    borderBottom: `1px solid ${theme.palette.border.light}`,
    marginBottom: '10px',
  },
  menuPaper: {
    top: '80px !important',
    paddingLeft: '10px',
    paddingRight: '10px',
    '& ul': {
      '& li:focus': {
        backgroundColor: 'rgba(0, 0, 0, 0) !important',
        outlineStyle: 'solid',
        outlineColor: theme.palette.primary.dark,
      },
    },
  },
});

export default styles;
